export const siteConfig = {
  name: '苹果视频',
  description: '苹果视频提供免费观看西瓜视频免费、免费视频网站91等热门影视，高清电影电视剧全集资源，在线播放流畅不缓冲，免费看个够。',
  keywords: '苹果视频,免费观看,西瓜视频免费,免费视频网站91,高清,在线播放,不缓冲,电影,电视剧,全集,免费资源',
  url: 'https://www.pingguoshipin.com',
  ogImage: 'https://readdy.ai/api/search-image?query=Cinematic%20atmosphere%20with%20film%20reel%20and%20warm%20red%20and%20gold%20lighting%2C%20abstract%20movie%20themed%20background%20with%20soft%20gradients%2C%20professional%20streaming%20platform%20visual%20identity%2C%20clean%20modern%20design%20elements%2C%20luxurious%20cinema%20aesthetic%20with%20subtle%20film%20texture%2C%20high%20quality%20brand%20image&width=1200&height=630&seq=og-home-01&orientation=landscape',
  logo: '苹果视频',
  email: 'contact@pingguoshipin.com',
  phone: '400-888-0000',
  address: '北京市朝阳区望京科技园A座18层',
  founded: '2018',
  socialMedia: {
    weibo: 'https://weibo.com/pingguoshipin',
    wechat: 'pingguoshipin',
  },
};